module.exports = __webpack_public_path__ + "media/images/icon-search-752ac3e21af65c4bda84a7b9e9ef6270.svg";